import React from 'react';
import { Quote } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  name: 'Martín P.',
  role: 'Buenos Aires — PROFE DE NATACIÓN EN NATATORIO',
  text: 'Compré un domingo a la noche. El lunes entré a la pileta con el plan exacto de la clase. El Tomo 2 es exactamente lo que necesitaba para mis grupos de distintos niveles. Nunca más improviso una sesión.'
}, {
  initials: 'LG',
  name: 'Laura G.',
  role: 'Rosario — PROFE EN CLUB DEPORTIVO',
  text: 'El Tomo 4, el de grupos especiales, me cambió todo. El primer mes, alumnos que llevaban tiempo estancados mejoraron visiblemente su técnica. Las progresiones son únicas en el mercado.'
}, {
  initials: 'DR',
  name: 'Diego R.',
  role: 'Córdoba — PROFE GRUPAL E INDIVIDUAL',
  text: 'El sistema de progresión es único. 12 clases listas para usar en cada nivel, con las indicaciones técnicas descriptas paso a paso. Antes tardaba horas armando una sesión. Ahora abro el PDF y en 5 minutos tengo todo listo.'
}, {
  initials: 'VP',
  name: 'Valeria P.',
  role: 'Tucumán — PROFE PARTICULAR Y EN NATATORIO',
  text: 'Las Planillas de Seguimiento del Bono 2 eliminaron mi inseguridad al evaluar a mis alumnos. Ahora sé exactamente en qué están y qué necesitan. Mis clases tienen otro nivel de profesionalismo.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  role: 'Mendoza — PROFE DE NATACIÓN EN NATATORIO MUNICIPAL',
  text: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión del Tomo 1. Los alumnos ahora quieren venir porque siempre hay algo nuevo.'
}, {
  initials: 'SV',
  name: 'Sandra V.',
  role: 'Santa Fe — PROFE EN CLUB Y PILETA MUNICIPAL',
  text: 'El Tomo 6 de gestión me salvó de seguir cobrando lo mismo de siempre. Ahora tengo un sistema profesional visible que me permite justificar mis tarifas. Mi club me reconoce como el profe más organizado.'
}, {
  initials: 'GR',
  name: 'Gastón R.',
  role: 'Salta — PROFE EN CLUB Y PILETA PRIVADA',
  text: 'El Pack Élite me cambió la cabeza. Nunca había dimensionado el potencial de armar mi propia escuela de natación. Ahora trabajo con una seguridad y una estructura que antes no tenía.'
}];
export function TestimonialsSection() {
  return <section className="bg-gray-50 py-8 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-362">
      <div className="max-w-6xl mx-auto" data-id="element-363">
        <div className="text-center mb-6 sm:mb-12" data-id="element-364">
          <h2 className="text-3xl sm:text-4xl font-black text-deep mb-4" data-id="element-365">
            Lo que dicen los profes que ya lo usan
          </h2>
          <p className="text-lg text-gray-600 font-medium" data-id="element-366">
            +500 profes de natación de todo el país ya tienen su Profe de
            Natación Resuelto™
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6" data-id="element-367">
          {testimonials.map((t, idx) => <div key={idx} className={`bg-white p-4 sm:p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full ${idx === testimonials.length - 1 && testimonials.length % 2 !== 0 ? 'md:col-span-2 md:max-w-2xl md:mx-auto w-full' : ''}`} data-id="element-368">
              <Quote className="w-8 h-8 text-agua/30 mb-4" data-id="element-369" />
              <p className="text-gray-700 text-base italic mb-3 sm:mb-6 flex-grow" data-id="element-370">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4 mt-auto pt-4 border-t border-gray-50" data-id="element-371">
                <div className="w-12 h-12 rounded-full bg-light flex items-center justify-center text-deep font-bold text-lg border border-agua/30 shrink-0" data-id="element-372">
                  {t.initials}
                </div>
                <div data-id="element-373">
                  <p className="text-deep font-bold text-base" data-id="element-374">{t.name}</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wide font-medium" data-id="element-375">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}